var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 620,
    height: 526,
    viewBox: "0 0 620 526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14582",
    "data-name": "Group 14582",
    transform: "translate(-1063 -4629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14257",
    "data-name": "Group 14257",
    transform: "translate(777.458 3374.42)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3352",
    "data-name": "Ellipse 3352",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2566",
    "data-name": "Ellipse 2566",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3362",
    "data-name": "Ellipse 3362",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2539",
    "data-name": "Ellipse 2539",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3353",
    "data-name": "Ellipse 3353",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2567",
    "data-name": "Ellipse 2567",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3363",
    "data-name": "Ellipse 3363",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-2",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3364",
    "data-name": "Ellipse 3364",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2568",
    "data-name": "Ellipse 2568",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3365",
    "data-name": "Ellipse 3365",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2540",
    "data-name": "Ellipse 2540",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3366",
    "data-name": "Ellipse 3366",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2569",
    "data-name": "Ellipse 2569",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3367",
    "data-name": "Ellipse 3367",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-3",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3368",
    "data-name": "Ellipse 3368",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2570",
    "data-name": "Ellipse 2570",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3369",
    "data-name": "Ellipse 3369",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2541",
    "data-name": "Ellipse 2541",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3370",
    "data-name": "Ellipse 3370",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2571",
    "data-name": "Ellipse 2571",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3371",
    "data-name": "Ellipse 3371",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-4",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3372",
    "data-name": "Ellipse 3372",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2572",
    "data-name": "Ellipse 2572",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3373",
    "data-name": "Ellipse 3373",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2534",
    "data-name": "Ellipse 2534",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3374",
    "data-name": "Ellipse 3374",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2573",
    "data-name": "Ellipse 2573",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3375",
    "data-name": "Ellipse 3375",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-5",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3448",
    "data-name": "Ellipse 3448",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2561",
    "data-name": "Ellipse 2561",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3449",
    "data-name": "Ellipse 3449",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2531",
    "data-name": "Ellipse 2531",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3450",
    "data-name": "Ellipse 3450",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2574",
    "data-name": "Ellipse 2574",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3451",
    "data-name": "Ellipse 3451",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-6",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3354",
    "data-name": "Ellipse 3354",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2575",
    "data-name": "Ellipse 2575",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3376",
    "data-name": "Ellipse 3376",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2542",
    "data-name": "Ellipse 2542",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3355",
    "data-name": "Ellipse 3355",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2576",
    "data-name": "Ellipse 2576",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3377",
    "data-name": "Ellipse 3377",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-7",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3378",
    "data-name": "Ellipse 3378",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2577",
    "data-name": "Ellipse 2577",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3379",
    "data-name": "Ellipse 3379",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2543",
    "data-name": "Ellipse 2543",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3380",
    "data-name": "Ellipse 3380",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2578",
    "data-name": "Ellipse 2578",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3381",
    "data-name": "Ellipse 3381",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-8",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3382",
    "data-name": "Ellipse 3382",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2579",
    "data-name": "Ellipse 2579",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3383",
    "data-name": "Ellipse 3383",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2544",
    "data-name": "Ellipse 2544",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3384",
    "data-name": "Ellipse 3384",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2580",
    "data-name": "Ellipse 2580",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3385",
    "data-name": "Ellipse 3385",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-9",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3386",
    "data-name": "Ellipse 3386",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2581",
    "data-name": "Ellipse 2581",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3387",
    "data-name": "Ellipse 3387",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2535",
    "data-name": "Ellipse 2535",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3388",
    "data-name": "Ellipse 3388",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2582",
    "data-name": "Ellipse 2582",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3389",
    "data-name": "Ellipse 3389",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-10",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3452",
    "data-name": "Ellipse 3452",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2562",
    "data-name": "Ellipse 2562",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3453",
    "data-name": "Ellipse 3453",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2532",
    "data-name": "Ellipse 2532",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3454",
    "data-name": "Ellipse 3454",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2583",
    "data-name": "Ellipse 2583",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3455",
    "data-name": "Ellipse 3455",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-11",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3356",
    "data-name": "Ellipse 3356",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2584",
    "data-name": "Ellipse 2584",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3390",
    "data-name": "Ellipse 3390",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2545",
    "data-name": "Ellipse 2545",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3357",
    "data-name": "Ellipse 3357",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2585",
    "data-name": "Ellipse 2585",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3391",
    "data-name": "Ellipse 3391",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-12",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3392",
    "data-name": "Ellipse 3392",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2586",
    "data-name": "Ellipse 2586",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3393",
    "data-name": "Ellipse 3393",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2546",
    "data-name": "Ellipse 2546",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3394",
    "data-name": "Ellipse 3394",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2587",
    "data-name": "Ellipse 2587",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3395",
    "data-name": "Ellipse 3395",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-13",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3396",
    "data-name": "Ellipse 3396",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2588",
    "data-name": "Ellipse 2588",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3397",
    "data-name": "Ellipse 3397",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2547",
    "data-name": "Ellipse 2547",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3398",
    "data-name": "Ellipse 3398",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2589",
    "data-name": "Ellipse 2589",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3399",
    "data-name": "Ellipse 3399",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-14",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3400",
    "data-name": "Ellipse 3400",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2590",
    "data-name": "Ellipse 2590",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3401",
    "data-name": "Ellipse 3401",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2536",
    "data-name": "Ellipse 2536",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3402",
    "data-name": "Ellipse 3402",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2591",
    "data-name": "Ellipse 2591",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3403",
    "data-name": "Ellipse 3403",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-15",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3456",
    "data-name": "Ellipse 3456",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2563",
    "data-name": "Ellipse 2563",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3457",
    "data-name": "Ellipse 3457",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2533",
    "data-name": "Ellipse 2533",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3458",
    "data-name": "Ellipse 3458",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2592",
    "data-name": "Ellipse 2592",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3459",
    "data-name": "Ellipse 3459",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-16",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3358",
    "data-name": "Ellipse 3358",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2593",
    "data-name": "Ellipse 2593",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3404",
    "data-name": "Ellipse 3404",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2548",
    "data-name": "Ellipse 2548",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3359",
    "data-name": "Ellipse 3359",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2594",
    "data-name": "Ellipse 2594",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3405",
    "data-name": "Ellipse 3405",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-17",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3406",
    "data-name": "Ellipse 3406",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2595",
    "data-name": "Ellipse 2595",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3407",
    "data-name": "Ellipse 3407",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2549",
    "data-name": "Ellipse 2549",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3408",
    "data-name": "Ellipse 3408",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2596",
    "data-name": "Ellipse 2596",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3409",
    "data-name": "Ellipse 3409",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-18",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3410",
    "data-name": "Ellipse 3410",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2597",
    "data-name": "Ellipse 2597",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3411",
    "data-name": "Ellipse 3411",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2550",
    "data-name": "Ellipse 2550",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3412",
    "data-name": "Ellipse 3412",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2598",
    "data-name": "Ellipse 2598",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3413",
    "data-name": "Ellipse 3413",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-19",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3414",
    "data-name": "Ellipse 3414",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2599",
    "data-name": "Ellipse 2599",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3415",
    "data-name": "Ellipse 3415",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2537",
    "data-name": "Ellipse 2537",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3416",
    "data-name": "Ellipse 3416",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2600",
    "data-name": "Ellipse 2600",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3417",
    "data-name": "Ellipse 3417",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-20",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3460",
    "data-name": "Ellipse 3460",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2564",
    "data-name": "Ellipse 2564",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3461",
    "data-name": "Ellipse 3461",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2538",
    "data-name": "Ellipse 2538",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3462",
    "data-name": "Ellipse 3462",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2601",
    "data-name": "Ellipse 2601",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3463",
    "data-name": "Ellipse 3463",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-21",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3360",
    "data-name": "Ellipse 3360",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2602",
    "data-name": "Ellipse 2602",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3418",
    "data-name": "Ellipse 3418",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2551",
    "data-name": "Ellipse 2551",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3419",
    "data-name": "Ellipse 3419",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2603",
    "data-name": "Ellipse 2603",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3420",
    "data-name": "Ellipse 3420",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-22",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3421",
    "data-name": "Ellipse 3421",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2604",
    "data-name": "Ellipse 2604",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3422",
    "data-name": "Ellipse 3422",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2552",
    "data-name": "Ellipse 2552",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3423",
    "data-name": "Ellipse 3423",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2605",
    "data-name": "Ellipse 2605",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3424",
    "data-name": "Ellipse 3424",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-23",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3425",
    "data-name": "Ellipse 3425",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2606",
    "data-name": "Ellipse 2606",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3426",
    "data-name": "Ellipse 3426",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2553",
    "data-name": "Ellipse 2553",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3427",
    "data-name": "Ellipse 3427",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2607",
    "data-name": "Ellipse 2607",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3428",
    "data-name": "Ellipse 3428",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-24",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3429",
    "data-name": "Ellipse 3429",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2608",
    "data-name": "Ellipse 2608",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3430",
    "data-name": "Ellipse 3430",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2554",
    "data-name": "Ellipse 2554",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3431",
    "data-name": "Ellipse 3431",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2609",
    "data-name": "Ellipse 2609",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3432",
    "data-name": "Ellipse 3432",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-25",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3464",
    "data-name": "Ellipse 3464",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2565",
    "data-name": "Ellipse 2565",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3465",
    "data-name": "Ellipse 3465",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2555",
    "data-name": "Ellipse 2555",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3466",
    "data-name": "Ellipse 3466",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2610",
    "data-name": "Ellipse 2610",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3467",
    "data-name": "Ellipse 3467",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-26",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3361",
    "data-name": "Ellipse 3361",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2611",
    "data-name": "Ellipse 2611",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3433",
    "data-name": "Ellipse 3433",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2556",
    "data-name": "Ellipse 2556",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3434",
    "data-name": "Ellipse 3434",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2612",
    "data-name": "Ellipse 2612",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3435",
    "data-name": "Ellipse 3435",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(344.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-27",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3436",
    "data-name": "Ellipse 3436",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2613",
    "data-name": "Ellipse 2613",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3437",
    "data-name": "Ellipse 3437",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2557",
    "data-name": "Ellipse 2557",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3438",
    "data-name": "Ellipse 3438",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2614",
    "data-name": "Ellipse 2614",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3439",
    "data-name": "Ellipse 3439",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(356.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-28",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3440",
    "data-name": "Ellipse 3440",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2615",
    "data-name": "Ellipse 2615",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3441",
    "data-name": "Ellipse 3441",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2558",
    "data-name": "Ellipse 2558",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3442",
    "data-name": "Ellipse 3442",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2616",
    "data-name": "Ellipse 2616",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3443",
    "data-name": "Ellipse 3443",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-29",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3444",
    "data-name": "Ellipse 3444",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2617",
    "data-name": "Ellipse 2617",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3445",
    "data-name": "Ellipse 3445",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2559",
    "data-name": "Ellipse 2559",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3446",
    "data-name": "Ellipse 3446",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2618",
    "data-name": "Ellipse 2618",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3447",
    "data-name": "Ellipse 3447",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(379.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-30",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3468",
    "data-name": "Ellipse 3468",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2619",
    "data-name": "Ellipse 2619",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3469",
    "data-name": "Ellipse 3469",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2560",
    "data-name": "Ellipse 2560",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3470",
    "data-name": "Ellipse 3470",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2620",
    "data-name": "Ellipse 2620",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3471",
    "data-name": "Ellipse 3471",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(391.542 1525.58)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14258",
    "data-name": "Group 14258",
    transform: "translate(2937.58 4818.458) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-31",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3623",
    "data-name": "Ellipse 3623",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2566-2",
    "data-name": "Ellipse 2566",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3624",
    "data-name": "Ellipse 3624",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2539-2",
    "data-name": "Ellipse 2539",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3625",
    "data-name": "Ellipse 3625",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-32",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3627",
    "data-name": "Ellipse 3627",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2568-2",
    "data-name": "Ellipse 2568",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3628",
    "data-name": "Ellipse 3628",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2540-2",
    "data-name": "Ellipse 2540",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3629",
    "data-name": "Ellipse 3629",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-33",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3631",
    "data-name": "Ellipse 3631",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2570-2",
    "data-name": "Ellipse 2570",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3632",
    "data-name": "Ellipse 3632",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2541-2",
    "data-name": "Ellipse 2541",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3633",
    "data-name": "Ellipse 3633",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-34",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3695",
    "data-name": "Ellipse 3695",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2572-2",
    "data-name": "Ellipse 2572",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3696",
    "data-name": "Ellipse 3696",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2534-2",
    "data-name": "Ellipse 2534",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3697",
    "data-name": "Ellipse 3697",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-35",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2561-2",
    "data-name": "Ellipse 2561",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2531-2",
    "data-name": "Ellipse 2531",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-36",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3635",
    "data-name": "Ellipse 3635",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2575-2",
    "data-name": "Ellipse 2575",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3636",
    "data-name": "Ellipse 3636",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2542-2",
    "data-name": "Ellipse 2542",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3637",
    "data-name": "Ellipse 3637",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-37",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3639",
    "data-name": "Ellipse 3639",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2577-2",
    "data-name": "Ellipse 2577",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3640",
    "data-name": "Ellipse 3640",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2543-2",
    "data-name": "Ellipse 2543",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3641",
    "data-name": "Ellipse 3641",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-38",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3643",
    "data-name": "Ellipse 3643",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2579-2",
    "data-name": "Ellipse 2579",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3644",
    "data-name": "Ellipse 3644",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2544-2",
    "data-name": "Ellipse 2544",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3645",
    "data-name": "Ellipse 3645",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-39",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3699",
    "data-name": "Ellipse 3699",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2581-2",
    "data-name": "Ellipse 2581",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3700",
    "data-name": "Ellipse 3700",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2535-2",
    "data-name": "Ellipse 2535",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3701",
    "data-name": "Ellipse 3701",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-40",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2562-2",
    "data-name": "Ellipse 2562",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2532-2",
    "data-name": "Ellipse 2532",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-41",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3647",
    "data-name": "Ellipse 3647",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2584-2",
    "data-name": "Ellipse 2584",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3648",
    "data-name": "Ellipse 3648",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2545-2",
    "data-name": "Ellipse 2545",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3649",
    "data-name": "Ellipse 3649",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-42",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3651",
    "data-name": "Ellipse 3651",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2586-2",
    "data-name": "Ellipse 2586",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3652",
    "data-name": "Ellipse 3652",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2546-2",
    "data-name": "Ellipse 2546",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3653",
    "data-name": "Ellipse 3653",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-43",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3655",
    "data-name": "Ellipse 3655",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2588-2",
    "data-name": "Ellipse 2588",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3656",
    "data-name": "Ellipse 3656",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2547-2",
    "data-name": "Ellipse 2547",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3657",
    "data-name": "Ellipse 3657",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-44",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3703",
    "data-name": "Ellipse 3703",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2590-2",
    "data-name": "Ellipse 2590",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3704",
    "data-name": "Ellipse 3704",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2536-2",
    "data-name": "Ellipse 2536",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3705",
    "data-name": "Ellipse 3705",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-45",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2563-2",
    "data-name": "Ellipse 2563",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2533-2",
    "data-name": "Ellipse 2533",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-46",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3659",
    "data-name": "Ellipse 3659",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2593-2",
    "data-name": "Ellipse 2593",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3660",
    "data-name": "Ellipse 3660",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2548-2",
    "data-name": "Ellipse 2548",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3661",
    "data-name": "Ellipse 3661",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-47",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3663",
    "data-name": "Ellipse 3663",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2595-2",
    "data-name": "Ellipse 2595",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3664",
    "data-name": "Ellipse 3664",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2549-2",
    "data-name": "Ellipse 2549",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3665",
    "data-name": "Ellipse 3665",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-48",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3667",
    "data-name": "Ellipse 3667",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2597-2",
    "data-name": "Ellipse 2597",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3668",
    "data-name": "Ellipse 3668",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2550-2",
    "data-name": "Ellipse 2550",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3669",
    "data-name": "Ellipse 3669",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-49",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3707",
    "data-name": "Ellipse 3707",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2599-2",
    "data-name": "Ellipse 2599",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3708",
    "data-name": "Ellipse 3708",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2537-2",
    "data-name": "Ellipse 2537",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3709",
    "data-name": "Ellipse 3709",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-50",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2564-2",
    "data-name": "Ellipse 2564",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2538-2",
    "data-name": "Ellipse 2538",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-51",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3671",
    "data-name": "Ellipse 3671",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2602-2",
    "data-name": "Ellipse 2602",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3672",
    "data-name": "Ellipse 3672",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2551-2",
    "data-name": "Ellipse 2551",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3673",
    "data-name": "Ellipse 3673",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-52",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3675",
    "data-name": "Ellipse 3675",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2604-2",
    "data-name": "Ellipse 2604",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3676",
    "data-name": "Ellipse 3676",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2552-2",
    "data-name": "Ellipse 2552",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3677",
    "data-name": "Ellipse 3677",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-53",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3679",
    "data-name": "Ellipse 3679",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2606-2",
    "data-name": "Ellipse 2606",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3680",
    "data-name": "Ellipse 3680",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2553-2",
    "data-name": "Ellipse 2553",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3681",
    "data-name": "Ellipse 3681",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-54",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3711",
    "data-name": "Ellipse 3711",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2608-2",
    "data-name": "Ellipse 2608",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3712",
    "data-name": "Ellipse 3712",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2554-2",
    "data-name": "Ellipse 2554",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3713",
    "data-name": "Ellipse 3713",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-55",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2565-2",
    "data-name": "Ellipse 2565",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2555-2",
    "data-name": "Ellipse 2555",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-56",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3683",
    "data-name": "Ellipse 3683",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2611-2",
    "data-name": "Ellipse 2611",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3684",
    "data-name": "Ellipse 3684",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2556-2",
    "data-name": "Ellipse 2556",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3685",
    "data-name": "Ellipse 3685",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(238.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-57",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3687",
    "data-name": "Ellipse 3687",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2613-2",
    "data-name": "Ellipse 2613",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3688",
    "data-name": "Ellipse 3688",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2557-2",
    "data-name": "Ellipse 2557",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3689",
    "data-name": "Ellipse 3689",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(250.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-58",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3691",
    "data-name": "Ellipse 3691",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2615-2",
    "data-name": "Ellipse 2615",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3692",
    "data-name": "Ellipse 3692",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2558-2",
    "data-name": "Ellipse 2558",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3693",
    "data-name": "Ellipse 3693",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(262.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-59",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3715",
    "data-name": "Ellipse 3715",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2617-2",
    "data-name": "Ellipse 2617",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3716",
    "data-name": "Ellipse 3716",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2559-2",
    "data-name": "Ellipse 2559",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3717",
    "data-name": "Ellipse 3717",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(273.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-60",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2619-2",
    "data-name": "Ellipse 2619",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2560-2",
    "data-name": "Ellipse 2560",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1384.58)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3903",
    "data-name": "Rectangle 3903",
    transform: "translate(1098 4656)",
    fill: "#fff",
    stroke: "#d7dfe6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 555,
    height: 475,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 554,
    height: 474,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14253",
    "data-name": "Group 14253",
    transform: "translate(1275.735 4752)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Deposit",
    transform: "translate(6.265 18)",
    fill: "#111",
    fontSize: 17,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Deposit")), /*#__PURE__*/React.createElement("text", {
    id: "_21_600.00_2_36_000.00_3_54_053.00_25_000.00_12_500.00",
    "data-name": "21,600.00 2,36,000.00 3,54,053.00 25,000.00 12,500.00",
    transform: "translate(72.265 85)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -71.2,
    y: 0
  }, "21,600.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -88.72,
    y: 65
  }, "2,36,000.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -88.848,
    y: 130
  }, "3,54,053.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -76.016,
    y: 195
  }, "25,000.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -71.088,
    y: 260
  }, "12,500.00"))), /*#__PURE__*/React.createElement("text", {
    id: "Balances",
    transform: "translate(1127 4708)",
    fill: "#111",
    fontSize: 24,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Balances")), /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    x2: 554.244,
    transform: "translate(1098 4865.5)",
    fill: "none",
    stroke: "#eff2f4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    x2: 554.244,
    transform: "translate(1098.5 4791.5)",
    fill: "none",
    stroke: "#eff2f4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    x2: 554.244,
    transform: "translate(1098 4931.5)",
    fill: "none",
    stroke: "#eff2f4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    x2: 554.244,
    transform: "translate(1098 4997.5)",
    fill: "none",
    stroke: "#eff2f4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298",
    "data-name": "Line 298",
    x2: 554.244,
    transform: "translate(1098 5062.5)",
    fill: "none",
    stroke: "#eff2f4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3904",
    "data-name": "Rectangle 3904",
    width: 555,
    height: 67,
    transform: "translate(1098 4865)",
    fill: "#242784",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3905",
    "data-name": "Rectangle 3905",
    width: 555,
    height: 66,
    transform: "translate(1098 4997)",
    fill: "#242784",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("text", {
    id: "Withdrawals",
    transform: "translate(1399 4770)",
    fill: "#111",
    fontSize: 17,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Withdrawals")), /*#__PURE__*/React.createElement("text", {
    id: "_10_600.00_1_50_000.00_2_02_055.00_13_200.00_6_500.00",
    "data-name": "10,600.00 1,50,000.00 2,02,055.00 13,200.00 6,500.00",
    transform: "translate(1509 4837)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -72.048,
    y: 0
  }, "10,600.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -85.152,
    y: 65
  }, "1,50,000.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -88.384,
    y: 130
  }, "2,02,055.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -70.464,
    y: 195
  }, "13,200.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -66.928,
    y: 260
  }, "6,500.00")), /*#__PURE__*/React.createElement("text", {
    id: "_11_000.00_86_000.00_1_51_998.00_11_800.00_6_000.00",
    "data-name": "11,000.00 86,000.00 1,51,998.00 11,800.00 6,000.00",
    transform: "translate(1632 4837)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -67.008,
    y: 0
  }, "11,000.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -77.024,
    y: 65
  }, "86,000.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -80.336,
    y: 130
  }, "1,51,998.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -67.056,
    y: 195
  }, "11,800.00"), /*#__PURE__*/React.createElement("tspan", {
    x: -66.928,
    y: 260
  }, "6,000.00")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14264",
    "data-name": "Group 14264",
    transform: "translate(1560.549 4752)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Balance",
    transform: "translate(0.451 18)",
    fill: "#111",
    fontSize: 17,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Balance"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14255",
    "data-name": "Group 14255",
    transform: "translate(985 4536)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Currency",
    transform: "translate(142 234)",
    fill: "#111",
    fontSize: 17,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Currency")), /*#__PURE__*/React.createElement("text", {
    id: "SGD_USD_JPY_CNY_EUR",
    "data-name": "SGD USD JPY CNY EUR",
    transform: "translate(188 300)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SGD"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 66
  }, "USD"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 132
  }, "JPY"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 198
  }, "CNY"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 264
  }, "EUR")), /*#__PURE__*/React.createElement("g", {
    id: "_131-singapore",
    "data-name": "131-singapore",
    transform: "translate(142 200.663)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3037",
    "data-name": "Rectangle 3037",
    width: 31,
    height: 21,
    transform: "translate(0 85.337)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3038",
    "data-name": "Rectangle 3038",
    width: 31,
    height: 10,
    transform: "translate(0 85.337)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8401",
    "data-name": "Group 8401",
    transform: "translate(3.707 87.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M62.566,121.869a3.146,3.146,0,0,1,2.471-3.072,3.145,3.145,0,1,0,0,6.144A3.145,3.145,0,0,1,62.566,121.869Z",
    transform: "translate(-61.218 -118.724)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M135.6,122.435l.223.686h.722l-.584.424.223.686-.584-.424-.584.424.223-.686-.584-.424h.722Z",
    transform: "translate(-130.209 -122.21)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M106.684,144.7l.223.686h.722l-.584.424.223.686-.584-.424-.584.424.223-.686-.584-.424h.722Z",
    transform: "translate(-103.043 -143.123)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M164.519,144.7l.223.686h.722l-.584.424.223.686-.584-.424-.584.424.223-.686-.584-.424h.722Z",
    transform: "translate(-157.376 -143.123)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M153.389,178.087l.223.686h.722l-.584.424.223.686-.584-.424-.584.424.223-.686-.584-.424h.722Z",
    transform: "translate(-146.92 -174.493)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M117.815,178.087l.223.686h.722l-.584.424.223.686-.584-.424-.584.424.223-.686-.584-.424h.722Z",
    transform: "translate(-113.5 -174.493)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_185-united_states_of_america",
    "data-name": "185-united states of america",
    transform: "translate(142 265.669)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3039",
    "data-name": "Rectangle 3039",
    width: 31,
    height: 20.667,
    transform: "translate(0 85.331)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8402",
    "data-name": "Group 8402",
    transform: "translate(0 87.914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3040",
    "data-name": "Rectangle 3040",
    width: 31,
    height: 2.583,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3041",
    "data-name": "Rectangle 3041",
    width: 31,
    height: 2.583,
    transform: "translate(0 5.167)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3042",
    "data-name": "Rectangle 3042",
    width: 31,
    height: 2.583,
    transform: "translate(0 10.333)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3043",
    "data-name": "Rectangle 3043",
    width: 31,
    height: 2.583,
    transform: "translate(0 15.5)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3044",
    "data-name": "Rectangle 3044",
    width: 15.5,
    height: 11.128,
    transform: "translate(0 85.331)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8403",
    "data-name": "Group 8403",
    transform: "translate(1.574 87.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M83.42,160.624l-.25.768h-.807l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474h-.808Z",
    transform: "translate(-78.95 -157.853)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M83.669,207.165l-.249-.768-.25.768h-.807l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474Z",
    transform: "translate(-78.95 -200.854)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M27.307,207.165l-.249-.768-.25.768H26l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474Z",
    transform: "translate(-26.001 -200.854)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M27.058,160.624l-.25.768H26l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474h-.807Z",
    transform: "translate(-26.001 -157.853)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M83.42,114.85l-.25.768h-.807l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474h-.808Z",
    transform: "translate(-78.95 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M27.058,114.85l-.25.768H26l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474h-.807Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M139.782,160.624l-.25.768h-.807l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474h-.807Z",
    transform: "translate(-131.9 -157.853)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M140.031,207.165l-.249-.768-.25.768h-.807l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474Z",
    transform: "translate(-131.9 -200.854)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M196.394,207.165l-.249-.768-.25.768h-.807l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474Z",
    transform: "translate(-184.85 -200.854)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M196.145,160.624l-.25.768h-.807l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474h-.807Z",
    transform: "translate(-184.85 -157.853)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M139.782,114.85l-.25.768h-.807l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474h-.807Z",
    transform: "translate(-131.9 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M196.145,114.85l-.25.768h-.807l.653.474-.25.768.653-.474.653.474-.25-.768.653-.474h-.807Z",
    transform: "translate(-184.85 -114.85)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eu",
    transform: "translate(142 550.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M0,0H30.025V20.668H0Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7425",
    "data-name": "Group 7425",
    transform: "translate(8.144 3.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357",
    transform: "translate(5.851 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(0.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-6.819-23.7l-.293.975.488.1Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.724 0.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7352",
    "data-name": "Group 7352",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-2",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7353",
    "data-name": "Group 7353",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-3",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356",
    transform: "translate(1.312 1.936) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7354",
    "data-name": "Group 7354",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-4",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7355",
    "data-name": "Group 7355",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-5",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7363",
    "data-name": "Group 7363",
    transform: "translate(5.851 11.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b",
    transform: "translate(0.725 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-6",
    "data-name": "a",
    d: "M-6.819-23.7l-.293.975.488.1Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c",
    transform: "translate(0.724 0.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7358",
    "data-name": "Group 7358",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-7",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7359",
    "data-name": "Group 7359",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-8",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7362",
    "data-name": "Group 7362",
    transform: "translate(1.312 1.936) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-9",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-10",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "e",
    transform: "translate(0 0.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7369",
    "data-name": "Group 7369",
    transform: "translate(0 5.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-3",
    "data-name": "b",
    transform: "translate(0.725 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-11",
    "data-name": "a",
    d: "M-6.819-23.7l-.293.975.488.1Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-3",
    "data-name": "c",
    transform: "translate(0.724 0.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7364",
    "data-name": "Group 7364",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-12",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7365",
    "data-name": "Group 7365",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-13",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7368",
    "data-name": "Group 7368",
    transform: "translate(1.312 1.936) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7366",
    "data-name": "Group 7366",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-14",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7367",
    "data-name": "Group 7367",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-15",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7375",
    "data-name": "Group 7375",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 4.265, 2.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-4",
    "data-name": "b",
    transform: "translate(0.725 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-16",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-4",
    "data-name": "c",
    transform: "translate(0.724 0.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7370",
    "data-name": "Group 7370",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-17",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7371",
    "data-name": "Group 7371",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-18",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374",
    transform: "translate(1.312 1.936) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-19",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-20",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7381",
    "data-name": "Group 7381",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 3.242, 3.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-5",
    "data-name": "b",
    transform: "translate(0.725 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-21",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-5",
    "data-name": "c",
    transform: "translate(0.724 0.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-22",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-23",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7380",
    "data-name": "Group 7380",
    transform: "translate(1.312 1.936) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7378",
    "data-name": "Group 7378",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-24",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7379",
    "data-name": "Group 7379",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-25",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7387",
    "data-name": "Group 7387",
    transform: "translate(2.46 8.14) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-6",
    "data-name": "b",
    transform: "translate(0.725 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-26",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-6",
    "data-name": "c",
    transform: "translate(0.724 0.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-27",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7383",
    "data-name": "Group 7383",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-28",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7386",
    "data-name": "Group 7386",
    transform: "translate(1.312 1.936) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7384",
    "data-name": "Group 7384",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-29",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7385",
    "data-name": "Group 7385",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-30",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7393",
    "data-name": "Group 7393",
    transform: "translate(4.576 10.103) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-7",
    "data-name": "b",
    transform: "translate(0.725 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-31",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-7",
    "data-name": "c",
    transform: "translate(0.724 0.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7388",
    "data-name": "Group 7388",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-32",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7389",
    "data-name": "Group 7389",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-33",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7392",
    "data-name": "Group 7392",
    transform: "translate(1.312 1.936) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7390",
    "data-name": "Group 7390",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-34",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7391",
    "data-name": "Group 7391",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-35",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7424",
    "data-name": "Group 7424",
    transform: "translate(13.737 13.064) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7399",
    "data-name": "Group 7399",
    transform: "translate(0 5.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-8",
    "data-name": "b",
    transform: "translate(0.725 0.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-36",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-8",
    "data-name": "c",
    transform: "translate(0.724 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7394",
    "data-name": "Group 7394",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-37",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7395",
    "data-name": "Group 7395",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-38",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7398",
    "data-name": "Group 7398",
    transform: "translate(1.312 1.54) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7396",
    "data-name": "Group 7396",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-39",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7397",
    "data-name": "Group 7397",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-40",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7405",
    "data-name": "Group 7405",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 5.403, 11.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-9",
    "data-name": "b",
    transform: "translate(0.725 0.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-41",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-9",
    "data-name": "c",
    transform: "translate(0.724 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7400",
    "data-name": "Group 7400",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-42",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7401",
    "data-name": "Group 7401",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-43",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7404",
    "data-name": "Group 7404",
    transform: "translate(1.312 1.54) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7402",
    "data-name": "Group 7402",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-44",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7403",
    "data-name": "Group 7403",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-45",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7411",
    "data-name": "Group 7411",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 2.104, 10.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-10",
    "data-name": "b",
    transform: "translate(0.725 0.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-46",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-10",
    "data-name": "c",
    transform: "translate(0.724 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7406",
    "data-name": "Group 7406",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-47",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7407",
    "data-name": "Group 7407",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-48",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7410",
    "data-name": "Group 7410",
    transform: "translate(1.312 1.54) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7408",
    "data-name": "Group 7408",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-49",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7409",
    "data-name": "Group 7409",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-50",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7417",
    "data-name": "Group 7417",
    transform: "translate(0.619 3.899) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-11",
    "data-name": "b",
    transform: "translate(0.725 0.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-51",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-11",
    "data-name": "c",
    transform: "translate(0.724 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7412",
    "data-name": "Group 7412",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-52",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7413",
    "data-name": "Group 7413",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-53",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7416",
    "data-name": "Group 7416",
    transform: "translate(1.312 1.54) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7414",
    "data-name": "Group 7414",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-54",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7415",
    "data-name": "Group 7415",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-55",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7423",
    "data-name": "Group 7423",
    transform: "translate(2.735 1.936) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-12",
    "data-name": "b",
    transform: "translate(0.725 0.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-56",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-12",
    "data-name": "c",
    transform: "translate(0.724 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7418",
    "data-name": "Group 7418",
    transform: "translate(0.111 1.209) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-57",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7419",
    "data-name": "Group 7419",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.473, 1.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-58",
    "data-name": "a",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7422",
    "data-name": "Group 7422",
    transform: "translate(1.312 1.54) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7420",
    "data-name": "Group 7420",
    transform: "translate(1.131 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-59",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7421",
    "data-name": "Group 7421",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.104, 1.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-60",
    "data-name": "a",
    d: "M.293,0,0,.975l.488.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M.293,1.073,0,.1.488,0Z",
    transform: "translate(0.585 1.073) rotate(180)",
    fill: "#fc0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "_240-japan",
    "data-name": "240-japan",
    transform: "translate(142 415.331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 31,
    height: 20.667,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5.813,
    cy: 5.813,
    r: 5.813,
    transform: "translate(9.688 4.521)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_011-china",
    "data-name": "011-china",
    transform: "translate(142 483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3770",
    "data-name": "Rectangle 3770",
    width: 31.716,
    height: 21.145,
    transform: "translate(0 0)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13793",
    "data-name": "Group 13793",
    transform: "translate(7.238 5.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23316",
    "data-name": "Path 23316",
    d: "M120.683,189.567l.908,2.794h2.938l-2.377,1.727.908,2.794-2.377-1.727-2.377,1.727.908-2.794-2.377-1.727h2.938Z",
    transform: "translate(-116.837 -188.503)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23317",
    "data-name": "Path 23317",
    d: "M235.962,298.05l-.891-.648-.891.648.34-1.048-.891-.648h1.1l.34-1.048.341,1.048h1.1l-.891.648Z",
    transform: "translate(-226.393 -287.693)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23318",
    "data-name": "Path 23318",
    d: "M265.157,262.252h-1.1l-.34,1.048-.34-1.048h-1.1l.891-.648-.341-1.048.891.647.891-.647-.34,1.048Z",
    transform: "translate(-253.264 -255.096)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23319",
    "data-name": "Path 23319",
    d: "M265.157,208.195l-.891.648.34,1.048-.891-.648-.891.648.341-1.048-.891-.647h1.1l.34-1.048.34,1.048Z",
    transform: "translate(-253.264 -204.994)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23320",
    "data-name": "Path 23320",
    d: "M235.963,172.4l-.34,1.048.891.648h-1.1l-.341,1.048-.34-1.048h-1.1l.891-.648-.34-1.048.891.648Z",
    transform: "translate(-226.394 -172.396)",
    fill: "#ffda44"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank3);
export default __webpack_public_path__ + "static/media/bank-3.e8f089bcb3910a6d72d8cfea977fdd5c.svg";
export { ForwardRef as ReactComponent };